import { useReveal } from "@/hooks/useReveal";
import { APP_URL } from "@/lib/constants";
import { buildWhatsAppUrl } from "@/lib/utm";
import { StylistStatusBadge } from "@/components/landing/StylistStatusBadge";
import { trackEvent } from "@/lib/analytics";

export const FinalCTA = () => {
  const ref = useReveal();
  return (
    <section ref={ref} data-testid="final-cta-section" className="py-32 md:py-44 relative overflow-hidden" style={{ background: "var(--ink)" }}>
      <img
        src="/media/frame-6.jpg"
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-25"
      />
      <div
        className="absolute inset-0"
        style={{ background: "linear-gradient(180deg, rgba(6,4,10,0.75), rgba(6,4,10,0.55))" }}
      />
      <div className="pw-container relative text-center flex flex-col items-center">
        <span className="pw-eyebrow reveal !text-white/60">Angiolini VIP</span>
        <h2
          className="reveal mt-6 text-white font-semibold max-w-3xl"
          style={{ fontSize: "clamp(2.25rem, 5vw, 4.5rem)", letterSpacing: "-0.045em", lineHeight: 1.05 }}
        >
          Ваш доступ уже готов.
        </h2>
        <p className="reveal mt-6 text-white/60 max-w-lg text-base leading-relaxed">
          Присоединяйтесь к клубу Angiolini уже сегодня. Получите бонусы,
          откройте каталог, попробуйте виртуальную примерку и первыми узнавайте
          о новых коллекциях из Италии.
        </p>
        <div className="reveal mt-10 flex flex-col sm:flex-row items-center gap-4">
          <a
            href={APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-button"
            onClick={() => trackEvent("app_click", { location: "final_cta" })}
            className="pw-btn pw-btn-light btn-fill-gold !px-12 !py-5 !text-base"
          >
            <span className="fill-inner">
              Перейти в приложение
              <span className="fill-arrow" aria-hidden="true">→</span>
            </span>
          </a>
          <a
            href={buildWhatsAppUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-whatsapp"
            onClick={(e) => {
              e.currentTarget.href = buildWhatsAppUrl();
              trackEvent("whatsapp_click", { location: "final_cta" });
            }}
            className="inline-flex items-center gap-2 rounded-full px-8 py-4 text-sm md:text-base font-medium text-white transition-all duration-300 hover:scale-[1.02]"
            style={{
              background: "#25D366",
              boxShadow: "0 10px 30px rgba(37,211,102,0.4)",
            }}
          >
            <svg viewBox="0 0 32 32" width="20" height="20" fill="currentColor" aria-hidden="true">
              <path d="M19.11 17.32c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.5-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.49 1.07 2.89 1.22 3.09c.15.2 2.1 3.21 5.08 4.5.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2.01-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35zM16.03 26.34h-.01c-1.9 0-3.77-.51-5.4-1.48l-.39-.23-4.02 1.05 1.07-3.92-.25-.4c-1.06-1.69-1.62-3.64-1.62-5.65 0-5.85 4.76-10.6 10.62-10.6 2.83 0 5.5 1.1 7.5 3.11 2 2 3.11 4.67 3.11 7.5-.01 5.86-4.77 10.62-10.61 10.62zM27.06 4.94A15.42 15.42 0 0016.03 0C7.34 0 .28 7.06.28 15.75c0 2.78.73 5.49 2.11 7.87L.15 32l8.61-2.26a15.7 15.7 0 007.27 1.85h.01c8.68 0 15.75-7.06 15.75-15.75 0-4.21-1.64-8.16-4.73-11.13z" />
            </svg>
            <span>Или напишите в WhatsApp</span>
          </a>
        </div>
        <div className="reveal mt-6">
          <StylistStatusBadge />
        </div>
        <span className="reveal mt-4 text-white/45 text-[13px]">
          Не хотите разбираться в приложении? Напишите — стилист подберёт за вас.
        </span>
      </div>
    </section>
  );
};
